import React from 'react';
import { InlineWidget, CalendlyEventListener } from 'react-calendly';

export default class EventAddingWithCalendly extends React.Component {
  handleEventScheduled(e) {
    let dateObj = new Date(e.timeStamp * 1000);
    let utcString = dateObj.toUTCString();

    this.props.onEventScheduled(utcString);
  }
  componentDidMount() {}

  render() {
    const { suiteData, scheduling_url, propertyManagerDetails } = this.props;
    return (
      <>
        <CalendlyEventListener
          onEventScheduled={(e) => this.handleEventScheduled(e)}
        >
          <div
            style={{
              height: '630px',
              minWidth: '320px',
            }}
          >
            <InlineWidget
              url={
                scheduling_url +
                '?embed_domain=tcampb.github.io&embed_type=Inline'
              }
              prefill={{
                email:
                  suiteData.homeOwners && suiteData.homeOwners.email
                    ? suiteData.homeOwners.email
                    : '',
                firstName: suiteData.firstName,
                lastName: suiteData.lastName,
                phone: suiteData.phone,
                name:
                  propertyManagerDetails.propertyName +
                  ' : ' +
                  suiteData.number,
                customAnswers: {
                  a1: propertyManagerDetails.propertyName,
                  a2: suiteData.number,
                },
              }}
            />
          </div>
        </CalendlyEventListener>
      </>
    );
  }
}
